<ng-container *ngIf="state$ | async as state">

    <h2 mat-dialog-title class="pv-dialog-title">
        <mat-icon class="material-symbols-outlined">filter_alt</mat-icon>
        <span class="pv-dialog-title-text">Report Filter</span>
        <button mat-icon-button class="pv-dialog-close" (click)="cancel()" matTooltip="Close" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </h2>

    <!-- LOADING: white card loader -->
    <div class="pv-dialog-loading" *ngIf="state.status === 'LOADING'">
        <pv-spinner message="Loading filter…" fill="white"></pv-spinner>
    </div>

    <ng-container *ngIf="state.status === 'OK'">
        <mat-dialog-content class="pv-dialog-body">
            <form id="sample_form"
                [formGroup]="formGroup"
                (ngSubmit)="attempt()"
                novalidate
                autocomplete="no">

                <div class="two-col">
                    <div class="field-block">
                        <label class="field-label">Search sample label</label>
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-icon matPrefix>search</mat-icon>
                            <input type="text" matInput formControlName="search" placeholder="Enter sample label">
                        </mat-form-field>
                    </div>
                    <div class="field-block">
                        <label class="field-label">Variety</label>
                        <mat-form-field appearance="outline" class="full-width">
                            <pv-cultivar-autocomplete-chips
                                formControlName="scionCultivarKey"
                                [orgKey]="state.data.ownerOrgKey">
                            </pv-cultivar-autocomplete-chips>
                        </mat-form-field>
                    </div>
                </div>

                <div class="two-col">
                    <div class="field-block">
                        <label class="field-label">Filter location(s)</label>
                        <mat-form-field appearance="outline" class="full-width">
                            <pv-site-autocomplete-chips
                                formControlName="siteKey"
                                [orgKey]="state.data.ownerOrgKey">
                            </pv-site-autocomplete-chips>
                        </mat-form-field>
                    </div>
                    <div class="field-block">
                        <label class="field-label">Filter crop</label>
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-select formControlName="scionCropId" multiple placeholder="Any crop">
                                <mat-option *ngFor="let crop of cropOptions" [value]="crop.id">
                                    <mat-icon [svgIcon]="'common:' + crop.id"></mat-icon>
                                    <span>{{ crop.label }}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="two-col">
                    <div class="field-block">
                        <label class="field-label">Filter Licensee(s)</label>
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-select formControlName="licensee" multiple placeholder="Any licensee">
                                <mat-option *ngFor="let licensee of licenseeOptions$ | async" [value]="licensee">
                                    {{ licensee }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="field-block">
                        <label class="field-label">Harvest/Plant year</label>
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-select formControlName="birthYear" multiple placeholder="Any year">
                                <mat-option *ngFor="let year of yearOptions" [value]="year">{{ year }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="field-block">
                        <label class="field-label">Week</label>
                        <mat-form-field appearance="outline" class="full-width">
                            <mat-select formControlName="birthWeek" multiple placeholder="Any week">
                                <mat-option *ngFor="let week of weekOptions" [value]="week">{{ week }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <!-- TODO READ WHEN LOCKING LOGIC IS ADDED IN -->
                    <!-- <div class="toggle-wrapper">
                        <mat-icon *ngIf="lockControl.value" class="material-symbols-outlined">lock</mat-icon>
                        <mat-icon *ngIf="!lockControl.value"  class="material-symbols-outlined">lock_open_right</mat-icon>
                        <mat-slide-toggle formControlName="lock" color="primary" matTooltip="Lock report sample data based on current filter"></mat-slide-toggle>
                    </div> -->
                </div>

                <h4 class="form-subheader">Season Filter</h4>

                <div class="two-col">
                    <div class="field-block">
                        <label class="field-label">Season Month</label>
                        <mat-form-field appearance="outline" floatLabel="always" class="full-width">
                            <mat-select formControlName="seasonMonth">
                                <mat-option [value]="null">— None —</mat-option>
                                <mat-option *ngFor="let month of monthOptions" [value]="month.value">
                                    {{ month.label }}
                                </mat-option>
                            </mat-select>
                            <mat-error>Required when Season Year is set</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="field-block">
                        <label class="field-label">Season Year(s)</label>
                        <mat-form-field appearance="outline" floatLabel="always" class="full-width">
                            <mat-select formControlName="seasonYear" multiple>
                                <mat-option *ngFor="let year of yearOptions" [value]="year">
                                    {{ year }}
                                </mat-option>
                            </mat-select>
                            <mat-error>Required when Season Month is set</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="pv-dialog-footer">
            <button type="button" mat-stroked-button (click)="cancel()">Cancel</button>
            <button type="button" mat-flat-button color="primary" (click)="attempt()">
                <mat-icon>check</mat-icon>
                Apply
            </button>
        </mat-dialog-actions>
    </ng-container>
</ng-container>
